module.exports = __webpack_public_path__ + "static/media/anc18ru.24661da8.pdf";